<template>
  <div class="page-summary course-summary plan-summary">
    <div class="page-summary__section course-title">
      <div class="page-summary__label">{{ savedPlan.courseCode }}</div>
      <div class="page-summary__course-title">{{ savedPlan.courseName }}</div>
    </div>
    <div class="page-summary__section course-details">
      <dl v-if="savedPlan.selectedMajors" class="page-summary__value-pair">
        <div v-for="major in savedPlan.selectedMajors" :key="major.code">
          <dt class="page-summary__label">{{ major.code }}</dt>
          <dd class="page-summary__title">{{ major.name }}</dd>
        </div>
      </dl>
      <dl v-if="savedPlan.selectedMinors" class="page-summary__value-pair">
        <div v-for="minor in savedPlan.selectedMinors" :key="minor.code">
          <dt class="page-summary__label">{{ minor.code }}</dt>
          <dd class="page-summary__title">{{ minor.name }}</dd>
        </div>
      </dl>
    </div>
    <div class="page-summary__section student-pref">
      <dl class="page-summary__value-pair">
        <dt class="page-summary__label">Student type</dt>
        <dd>{{savedPlan.selectedPreferences.studentType}}</dd>
      </dl>
      <dl class="page-summary__value-pair">
        <dt class="page-summary__label">Load</dt>
        <dd>{{savedPlan.selectedPreferences.studyOption}}</dd>
      </dl>
      <dl class="page-summary__value-pair">
        <dt class="page-summary__label">Start date</dt>
        <dd>{{startPeriod}}, {{savedPlan.selectedPreferences.startYear}}</dd>
      </dl>
    </div>
    <div class="page-summary__section credits">
      <div class="page-summary__credits">{{ savedPlan.selectedCreditPoints }} / {{savedPlan.totalCreditPoints}}</div>
      <div class="page-summary__label">points selected</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import StudentPreferences from 'common/models/student-preferences.js'
export default {
  props: {
    savedPlan: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      studyPreference: 'preferences/getSelectedStudyPreferences'
    }),
    startPeriod() {
      const selected = this.savedPlan.selectedPreferences.teachingPeriod
      const teachingPeriod = StudentPreferences.courseloopOptionToTeachingPeriod(selected)
      return teachingPeriod ? teachingPeriod.shortLabel : selected
    }
  }
}
</script>
